import { mode } from 'd3';
import {
	getAllProjectsOfView,
	getAllProjectsForKanbanBoard,
	createProject,
	deleteProject,
	updateProject,
	getProject,
} from '../../actions/projectActions';
import { updateProjectViewSettings } from '../../actions/viewActions';

export const REQUEST_UPDATE_PROJECT_VIEW = 'request_update_project_view';
export const RECEIVE_UPDATE_PROJECT_VIEW = 'receive_update_project_view';
export const UPDATE_PROJECT_VIEW_ERROR = 'update_project_view_error';

export const REQUEST_PROJECTS = 'request_projects';
export const RECEIVE_PROJECTS = 'receive_projects';
export const RECEIVE_PROJECTS_ERROR = 'receive_projects_error';

export const REQUEST_ADD_PROJECT = 'request_add_project';
export const RECEIVE_ADD_PROJECT = 'receive_add_project';
export const ADD_PROJECT_ERROR = 'add_project_error';

export const RECEIVE_PROJECT = 'receive_project';
export const REQUEST_PROJECT = 'request_project';
export const GET_PROJECT_ERROR = 'get_project_error';

export const REQUEST_KANBAN_PROJECTS = 'request_kanban_projects';
export const RECEIVE_KANBAN_PROJECTS = 'receive_kanban_projects';
export const RECEIVE_KANBAN_PROJECTS_ERROR = 'receive_kanban_projects_error';

export const RECEIVE_DELETE_PROJECT = 'receive_delete_project';
export const REQUEST_DELETE_PROJECT = 'request_delete_project';
export const DELETE_PROJECT_ERROR = 'delete_project_errror';

// store local version of project in db
export const RECEIVE_SAVE_PROJECT = 'receive_save_project';
export const REQUEST_SAVE_PROJECT = 'request_save_project';
export const SAVE_PROJECT_ERROR = 'save_project_error';

export const UPDATE_RECO_MODE = 'update_reco_mode';

// Store updates of projects in redux for later saving (aka sending to api)
export const ADD_LOCAL_PROJECT_UPDATE = 'add_local_project_update';
export const DISCARD_PROJECT_UPDATES = 'discard_project_updates';

// Done.
const updateProjectViewSettingsRedux = (modelId, viewId, projectSettings) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_UPDATE_PROJECT_VIEW,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_UPDATE_PROJECT_VIEW,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: UPDATE_PROJECT_VIEW_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const view = await updateProjectViewSettings(modelId, viewId, projectSettings);

		return onSuccess(view);
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};

// Done.
const getAllProjectsOfViewRedux = (modelId, viewId) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_PROJECTS,
			payload: { viewId },
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_PROJECTS,
			payload: { projects: success, viewId },
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: RECEIVE_PROJECTS_ERROR,
			payload: { error, viewId },
		});
	};
	try {
		onRequest();
		// make api call
		const { projects } = await getAllProjectsOfView(modelId, viewId);
		return onSuccess(projects);
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

const getAllProjectsForKanbanBoardRedux = (modelId, viewId, layoutId) => async (dispatch) => {

	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_KANBAN_PROJECTS,
			payload: { modelId, viewId, layoutId },
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_KANBAN_PROJECTS,
			payload: { projects: success, viewId },
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: RECEIVE_KANBAN_PROJECTS_ERROR,
			payload: { error, viewId },
		});
	};
	try {
		onRequest();
		// make api call
		const projects = await getAllProjectsForKanbanBoard(modelId, viewId, layoutId);
		return onSuccess(projects);
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

// Done.
const createProjectRedux = (modelId, viewId, newProject) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_ADD_PROJECT,
			payload: { viewId },
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_ADD_PROJECT,
			payload: { project: success, viewId },
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: ADD_PROJECT_ERROR,
			payload: { error, viewId },
		});
	};
	try {
		onRequest();
		// make api call
		const response = await createProject(modelId, viewId, newProject);
		const { createdProject } = response;

		return onSuccess(createdProject);
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};

/**
 * Store an update of a projects value or an editable table in redux for later saving (aka sending to api)
 * @param {String} viewId
 * @param {String} projectId
 * @param {{action: String, id: String, updatedValue: Object}} projectUpdate
 * @returns
 */
const addLocalProjectUpdateRedux = (viewId, projectId, projectUpdate) => async (dispatch) => {
	/*
		ProjectUpdate = {
			action: "updateQualityGate" | "updateEditableTable" | "updateProjectInfo",
			id: String // id of the [editable table widget] or the [quality gate] or the [project info entry]
			updatedValue: Object // the new value
		}
	*/
	dispatch({
		type: ADD_LOCAL_PROJECT_UPDATE,
		payload: { viewId, projectId, projectUpdate },
	});
};

const discardProjectUpdatesRedux = (viewId, projectId) => async (dispatch) => {
	dispatch({
		type: DISCARD_PROJECT_UPDATES,
		payload: { viewId, projectId },
	});
};

/**
 * Sends all updates stored in the redux store to the api
 * @param {String} modelId
 * @param {String} viewId
 * @param {String} projectId
 * @returns
 */
const saveProjectRedux = (modelId, viewId, projectId, projectUpdates) => async (dispatch) => {
	const onRequest = () =>
		// dispatch request string to be handled by reducer
		dispatch({
			type: REQUEST_SAVE_PROJECT,
			payload: { viewId },
		});
	const onSuccess = (success) => {
		dispatch({
			// dispatch receive string and payload to be handled by reducer
			type: RECEIVE_SAVE_PROJECT,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dispatch error string and payload to be handled by reducer
			type: SAVE_PROJECT_ERROR,
			payload: { error, viewId },
		});
	};
	try {
		onRequest();

		const response = await updateProject(modelId, viewId, projectId, projectUpdates);

		const { project } = response;
		return onSuccess(project);
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};

// Done.
const getProjectRedux = (modelId, viewId, projectId) => async (dispatch) => {
	const onRequest = () => {
		dispatch({
			type: REQUEST_PROJECT,
			payload: { viewId },
		});
	};
	const onSuccess = (success) => {
		dispatch({
			type: RECEIVE_PROJECT,
			payload: success,
		});
		return success;
	};

	const onError = (error) => {
		dispatch({
			type: GET_PROJECT_ERROR,
			payload: { error, viewId },
		});
	};

	try {
		onRequest();

		const { project } = await getProject(modelId, viewId, projectId);
		return onSuccess(project);
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

const deleteProjectRedux = (modelId, viewId, projectId) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_DELETE_PROJECT,
			payload: { viewId },
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_DELETE_PROJECT,
			payload: { viewId, projectId },
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: DELETE_PROJECT_ERROR,
			payload: { viewId, error },
		});
	};
	try {
		onRequest();
		// make api call
		await deleteProject(modelId, viewId, projectId);
		return onSuccess();
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};

const updateRecoMode = (value) => (dispatch) =>
	dispatch({
		// dipatch error string and payload to be handled by reducer
		type: UPDATE_RECO_MODE,
		payload: value,
	});

export {
	addLocalProjectUpdateRedux,
	discardProjectUpdatesRedux,
	updateProjectViewSettingsRedux,
	createProjectRedux,
	getAllProjectsOfViewRedux,
	getAllProjectsForKanbanBoardRedux,
	getProjectRedux,
	deleteProjectRedux,
	saveProjectRedux,
	updateRecoMode,
};
